import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { SMSCertifiedConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class SMSCertifiedNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: SMSCertifiedConfig) {
    super(id, NodeType.SendCertifiedSMS, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['copyIds'].length == 0;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  override initNodeConfig() {
    (this.config as SMSCertifiedConfig).copyIds = [];
    (this.config as SMSCertifiedConfig).certified = true;
    (this.config as SMSCertifiedConfig).super = false;
    (this.config as SMSCertifiedConfig).sendToAllContacts = false;
    (this.config as SMSCertifiedConfig).expirationDays = 180;
    (this.config as SMSCertifiedConfig).expirationAt = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.config['copyIds'] == null) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'SMS Certificado',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }

  cloneWithConfig(newConfig: Partial<SMSCertifiedConfig>): SMSCertifiedNode {
    const cfg = {
      ...((this.config as SMSCertifiedConfig) || {}),
      ...newConfig,
    } as SMSCertifiedConfig;
    const clone = new SMSCertifiedNode(this.id, { x: this.position.x, y: this.position.y }, cfg);
    clone.childrenNodes = this.childrenNodes.slice();
    clone.parentNodes = this.parentNodes.slice();
    return clone;
  }
}
